import {normalizeImgUrlToThumb} from "../../utils/Helper";

export function Press({presses}){
    return (
        <section className="pt-3 position-relative bg-gradient-top-very-light-gray sm-pt-50px">
            <div className="container">
                <div className="row g-0">
                    <div className="col-12"
                         data-anime='{ "el": "childs", "translateY": [30, 0], "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 300, "easing": "easeOutQuad" }'>
                        <ul className="blog-grid blog-wrapper grid-loading grid grid-3col xl-grid-3col lg-grid-3col md-grid-2col sm-grid-2col xs-grid-1col gutter-extra-large"
                            data-anime='{ "el": "childs", "translateY": [50, 0], "opacity": [0,1], "duration": 600, "delay":0, "staggervalue": 150, "easing": "easeOutQuad" }'>
                            <li key={0} className="grid-sizer"></li>
                            {
                                presses.map((article, idx) => {
                                return <PressItem key={idx+1} article={article} ></PressItem>})
                            }
                        </ul>
                    </div>
                    <div className="col-12 mt-5 mb-5 d-flex justify-content-center"
                         data-anime='{ "el": "childs", "translateY": [0, 0], "opacity": [0,1], "duration": 600, "delay":0, "staggervalue": 150, "easing": "easeOutQuad" }'>
                    </div>
                </div>
            </div>
            <div className="shape-image-animation p-0 w-100 bottom-minus-40px xl-bottom-0px d-none d-md-block">
            </div>
        </section>


        /*
                                <ul className="pagination pagination-style-01 fs-13 fw-500 mb-0">
                            <li className="page-item">
                                <a className="page-link" href="#"><i
                                    className="feather icon-feather-arrow-left fs-18 d-xs-none"></i></a>
                            </li>
                            <li className="page-item">
                                <a className="page-link" href="#">01</a>
                            </li>
                            <li className="page-item active">
                                <a className="page-link" href="#">02</a>
                            </li>
                            <li className="page-item">
                                <a className="page-link" href="#">03</a>
                            </li>
                            <li className="page-item">
                                <a className="page-link" href="#">04</a>
                            </li>
                            <li className="page-item">
                                <a className="page-link" href="#"><i
                                    className="feather icon-feather-arrow-right fs-18 d-xs-none"></i></a>
                            </li>
                        </ul>
         */
    )
}


export function PressItem({article}){
    var thumbUrl=normalizeImgUrlToThumb(article.imgUrl);


    return(
        <li className="grid-item">
            <div
                className="card border-0 border-radius-5px box-shadow-quadruple-large box-shadow-quadruple-large-hover">
                <div className="blog-image"><a href={"sajto/"+article.slug}
                                               className="d-block"><img
                    src={thumbUrl??"https://placehold.co/600x430"} alt=""/></a>
                    <div className="blog-categories"><a href={"sajto/"+article.slug}
                                                        className="categories-btn bg-white text-dark-gray text-dark-gray-hover text-uppercase fw-700">{article.category}</a>
                    </div>
                </div>
                <div className="card-body p-13 md-p-11"><a
                    href={"sajto/"+article.slug}
                    className="card-title mb-15px fw-600 fs-18 lh-28 text-dark-gray d-inline-block w-90 md-w-100">{article.title}</a>
                    <p dangerouslySetInnerHTML={{ __html: article.lead }}></p>
                    <div
                        className="author d-flex justify-content-center align-items-center position-relative overflow-hidden fs-14 text-uppercase">
                        <div className="me-auto">
                        {article.publishedAt && (
                            <span
                                className="blog-date d-inline-block fw-600 text-dark-gray">{article.publishedAt}</span>
                        )}
                        {!article.publishedAt && (
                            <span
                                className="blog-date d-inline-block fw-600 text-dark-gray"></span>
                        )}
                        {article.author && (
                            <div className="d-inline-block author-name fw-600 text-dark-gray">Szerző: <a
                                className="text-dark-gray text-decoration-line-bottom">{article.author}</a>
                            </div>
                        )}
                        </div>
                    </div>
                </div>
            </div>
        </li>
    )
}
